import { useEffect } from 'react';
import "../../css/Modal.css"


function EventDetail({ t, data, setShowDetails }) {

	const closeText = t("page.close");

	let pointOfIntroductions = data.pointOfIntroductions.map(function(pointOfIntroduction) {
		return pointOfIntroduction.name;
	});
	let harms = data.harms.map(function(harm) {
		return harm.name;
	});
	let harmLocations = data.harmLocations.map(function(harmLocation) {
		return harmLocation.regionName + ", " + harmLocation.name + (harmLocation.state ? ", " + harmLocation.state : "") + (harmLocation.city ? ", " + harmLocation.city : "");
	});
	let originLocations = data.originatedLocations.map(function(originatedLocation) {
		return originatedLocation.regionName + ", " + originatedLocation.name + (originatedLocation.state ? ", " + originatedLocation.state : "") + (originatedLocation.city ? ", " + originatedLocation.city : "");
	});
	let foodCategories = data.foodCategories.map(function(foodCategory) {
		return foodCategory.name;
	});
	let motivations = data.motivations.map(function(motivation) {
		return motivation.name;
	});
	let adulterations = data.adulterations.map(function(adulteration) {
		return adulteration.name;
	});
	let brands = data.brands.map(function(brand) {
		return brand.name;
	});
	let adulteratedFoods = data.adulteratedFoods.map(function(adulteratedFood) {
		return adulteratedFood.name;
	});
	let affectedFoods = data.affectedFoods.map(function(affectedFood) {
		return affectedFood.name;
	});
	let adulterants = data.adulterants.map(function(adulterant) {
		return adulterant.name;
	});
	return (
		<div className="modalContainer hide-scrollbar">
			<div className="row">
				<div className="col mt-3">
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div className="row">
						<div className="col-12">
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.incidentSumm")}</dt>
									<dd>{data.incidentSummary} </dd>
								</dl>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.incidentType")}</dt>
									<dd>{data.typeName} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.harmType")}</dt>
									<dd>{harms.join(', ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.harmDesc")}</dt>
									<dd>{data.descriptionOfHarm} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.harmLoc")}</dt>
									<dd>{harmLocations.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.yearBegan")}</dt>
									<dd>{data.yearBegan} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.yearEnded")}</dt>
									<dd>{data.yearEnded} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.numIll")}</dt>
									<dd>{data.morbidityRange} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.numDeath")}</dt>
									<dd>{data.mortalityRange} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.foodCat")}</dt>
									<dd>{foodCategories.join(', ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.motivation")}</dt>
									<dd>{motivations.join(', ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.motivationDesc")}</dt>
									<dd>{data.descriptionOfMotivation} </dd>
								</dl>
							</div>
						</div>
						<div className="col-6">
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.ptIntro")}</dt>
									<dd>{pointOfIntroductions.join(', ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.ptIntroDesc")}</dt>
									<dd>{data.pointOfIntroductionDescription} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.primMethodAdu")}</dt>
									<dd>{data.adulterationName} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.secMethodAdu")}</dt>
									<dd>{adulterations.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.numRef")}</dt>
									<dd>{data.numberOfReferences} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.consumerBrand")}</dt>
									<dd>{brands.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.aduFoodProd")}</dt>
									<dd>{adulteratedFoods.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.affFoodProd")}</dt>
									<dd>{affectedFoods.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.adulterant")}</dt>
									<dd>{adulterants.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.qtyAdulterant")}</dt>
									<dd>{data.quantityOfAdulterantUsed} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.origLoc")}</dt>
									<dd>{originLocations.join('; ')} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.longTermImpact")}</dt>
									<dd>{data.longTermImpact} </dd>
								</dl>
							</div>
							<div className="form-group">
								<dl>
									<dt className="form-label">{t("page.history")}</dt>
									<dd>{data.history} </dd>
								</dl>
							</div>
						</div>
					</div>
					{data.citations && data.citations.length > 0 && (
						<div className="row">
							<div className="col-12">
								<dl>
									<dt>{t("page.citation")}</dt>
									<dd>
										<table className="table-cite">
											<thead>
												<tr>
													<th>{t("page.authors")}</th>
													<th>{t("page.date")}</th>
													<th>{t("page.title")}</th>
													<th>{t("page.source")}</th>
													<th>{t("page.volume")}</th>
												</tr>
											</thead>
											<tbody>
												<>
													{
														(data.citations.map((cite, citeIdx) => (
															<tr>
																<td>{cite.authors} </td>
																<td>{cite.publishDate}</td>
																<td>{cite.title}</td>
																<td>{cite.source} </td>
																<td>{cite.volumeNumber}</td>
															</tr>
														)))
													}
												</>
											</tbody>
										</table>
									</dd>
								</dl>

							</div>

						</div>
					)}
					<div className="footer">
						<input
							type="button"
							name="edit-close"
							id="edit-close"
							className="btn btn-secondary btn-block" data-dismiss="modal"
							onClick={(e) => setShowDetails(false)}
							style={{ marginRight: "50px" }}
							value={closeText}
						></input>


					</div>

				</div>
			</div>
		</div>
	);
}

export default EventDetail;